import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "resendAction", "trigger"]

  connect() {
    this.close()
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  open() {
    this.updateResendActionVisibility()
    this.panelTarget.classList.remove("translate-y-1", "opacity-0", "pointer-events-none")
    this.panelTarget.classList.add("translate-y-0", "opacity-100", "pointer-events-auto")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.classList.remove("translate-y-0", "opacity-100", "pointer-events-auto")
    this.panelTarget.classList.add("translate-y-1", "opacity-0", "pointer-events-none")
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  isOpen() {
    return this.panelTarget.classList.contains("opacity-100")
  }

  updateResendActionVisibility() {
    if (!this.hasResendActionTarget) return

    const incidentPathRegex =
      /\/sites\/[^/]+\/(?:incidents|performance\/incidents|exceptions\/incidents|logs\/incidents|anomalies\/incidents)\/[^/]+/
    const isIncidentPath = incidentPathRegex.test(window.location.pathname)

    this.resendActionTarget.classList.toggle("hidden", !isIncidentPath)
  }
}
